import React, { useId } from 'react';
import { JcCommonProps, JcUtils } from '../utils/JcUtils';
import { JcRadio } from './JcRadio';


export interface JcRadioGroupOption<T> {
  readonly id: T;
  readonly label: React.ReactNode;
}

export interface JcRadioGroupProps<T = string> extends JcCommonProps {
  /** Accessible name for the group (the visible label usually lives on a wrapping JcField). */
  readonly ariaLabel?: string;
  readonly options: JcRadioGroupOption<T>[];
  readonly value?: T;
  readonly onChange: (id: T) => void;
  readonly disabled?: boolean;
}


export const JcRadioGroup = <T,>(props: JcRadioGroupProps<T>): React.ReactElement => {
  const commonProps = JcUtils.commonProps(props, ["jc-radio-group"]);
  // One shared input name per group instance, so the radios form a native
  // group: a single tab stop with arrow-key selection.
  const name = useId();

  return <div role="radiogroup" aria-label={props.ariaLabel} {...commonProps}>
    {props.options.map(option => (
      <JcRadio
        key={String(option.id)}
        groupName={name}
        label={option.label}
        selected={option.id === props.value}
        disabled={props.disabled}
        onSelect={() => props.onChange(option.id)}
      />
    ))}
  </div>;
}
